import Lenis from 'lenis'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function smoothScroll() {
  const lenis = new Lenis({
    lerp: 0.075,
    wheelMultiplier: 1.3,
    touchMultiplier: 1.3,
  });

  lenis.on('scroll', ScrollTrigger.update);

  gsap.ticker.add((time) => {
    lenis.raf(time * 1000); // Convert time from seconds to milliseconds
  });

  const accordionTriggers = document.querySelectorAll('.js-accordion-trigger');

  if (accordionTriggers.length > 0 ) {
    accordionTriggers.forEach(btn => {
      btn.addEventListener('click', () => {
        setTimeout(() => lenis.scrollTo(btn.closest('.section-accordion__accordion-item'), { offset: -100, duration: 0.4, easing: (t) => t }), 500);
      });
    });
  }

  window.addEventListener('keydown', (event) => {
    const isEditable = ['INPUT', 'TEXTAREA'].includes(event.target.tagName) || event.target.isContentEditable;
  
    if (!isEditable  && event.code === 'Space') {
      event.preventDefault();
    }
  });  

  // Disable lag smoothing in GSAP to prevent any delay in scroll animations
  gsap.ticker.lagSmoothing(0);

}
